export var CollectivesModalitys = [
    "Basquetebol",
    "Futsal",
    "Handebol",
    "Voleibol",
];
export var InfantoIndividualsModalitys = [
    "Atletismo",
    "Águas Abertas",
    "Badminton",
    "Ciclismo",
    "Natação",
    "Taekwondô",
    "Tiro com Arco",
    "Triatlhon",
    "Vôlei de Praia",
    "Esgrima",
    "Judô",
    "Tênis de Mesa",
    "Wrestling - Luta Olímpica",
    "Ginástica artística",
];
export var InfantilIndividualsModalitys = [
    "Atletismo",
    "Atletismo Adptado",
    "Badminton",
    "Ciclismo",
    "Judô",
    "Karatê",
    "Natação",
    "Taekwondô",
    "Tênis de Mesa",
    "Vôlei de Praia",
    "Xadrez",
    "Wrestling - Luta Olímpica",
    "Ginástica artística",
];
export var CollectiveModalities = [
    "Feminino | 12 a 14 anos - Infantil | Basquete",
    "Feminino | 12 a 14 anos - Infantil | Futsal",
    "Feminino | 12 a 14 anos - Infantil | Handebol",
    "Feminino | 12 a 14 anos - Infantil | Voleibol",
    "Feminino | 12 a 14 anos - Infantil | Volei de praia",
    "Masculino | 12 a 14 anos - Infantil | Basquete",
    "Masculino | 12 a 14 anos - Infantil | Futsal",
    "Masculino | 12 a 14 anos - Infantil | Handebol",
    "Masculino | 12 a 14 anos - Infantil | Voleibol",
    "Masculino | 12 a 14 anos - Infantil | Volei de praia",
    "Feminino | 15 a 17 anos - Infanto| Basquete",
    "Feminino | 15 a 17 anos - Infanto | Futsal",
    "Feminino | 15 a 17 anos - Infanto | Handebol",
    "Feminino | 15 a 17 anos - Infanto | Voleibol",
    "Feminino | 15 a 17 anos - Infanto | Volei de praia",
    "Masculino | 15 a 17 anos - Infanto | Basquete",
    "Masculino | 15 a 17 anos - Infanto | Futsal",
    "Masculino | 15 a 17 anos - Infanto | Handebol",
    "Masculino | 15 a 17 anos - Infanto| Voleibol",
    "Masculino | 15 a 17 anos - Infanto| Volei de praia",
];
